"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import type { FC } from "react";
import { ErrorPageContent } from "@/components/ErrorPageContent/ErrorPageContent";
import { useNoOrgAccessState } from "./hooks/useNoOrgAccessState/useNoOrgAccessState";
export const NoOrgAccessState: FC = () => {
  const $ = _c(14);
  const t = useTranslations("navigation.no_org_access");
  const {
    handleSignOut,
    isLoggingOut
  } = useNoOrgAccessState();
  let t0;
  if ($[0] !== t) {
    t0 = t("title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("description");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("sign_out");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== handleSignOut || $[7] !== isLoggingOut || $[8] !== t2) {
    t3 = {
      label: t2,
      onClick: handleSignOut,
      isLoading: isLoggingOut
    };
    $[6] = handleSignOut;
    $[7] = isLoggingOut;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t0 || $[11] !== t1 || $[12] !== t3) {
    t4 = <div className="flex h-dvh w-dvw items-center justify-center bg-background"><ErrorPageContent errorCode="403" title={t0} description={t1} action={t3} /></div>;
    $[10] = t0;
    $[11] = t1;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};